// extracted by mini-css-extract-plugin
export var textInput = "_lg-0";